export default "2efcca13fd43b67c9c99e97bfef38db9.svg";